@if (layout(); as layout) { @if (layout === 'withContent') {
<div libFlexRow>
	<div libFlexColumn libFlexFill>
		<div
			class="ui-divider"
			[class.color-on-body]="color() === 'onBody'"
			[class.dotted]="mode() === 'dotted'"
		></div>
	</div>
	<div libFlexColumn>
		<ng-content></ng-content>
	</div>
	<div libFlexColumn libFlexFill>
		<div
			class="ui-divider"
			[class.color-on-body]="color() === 'onBody'"
			[class.dotted]="mode() === 'dotted'"
		></div>
	</div>
</div>
} @else {
<div class="ui-divider" [class.color-on-body]="color() === 'onBody'" [class.dotted]="mode() === 'dotted'"></div>

} }
